import React, { createContext, useContext, useState, ReactNode } from "react";

// Definicja interfejsu dla danych użytkownika
interface UserData {
  id: string;
  username: string;
  solarEdgeToken: string;
  solarmanToken: string;
  solarmanEmail: string;
  solarmanPassword: string;
  goodweEmail: string;
  goodwePassword: string;
  goodwePowerStationId: string;
  foxessKey: string;
  growattUser: string;
  growattPassword: string;
  fusionSolarUser: string;
  fusionSolarPassword: string;
}

// Definicja interfejsu dla kontekstu danych użytkownika
interface UserDataContextType {
  userData: UserData;
  updateUserData: (userData: Partial<UserData>) => void;
}

// Tworzenie kontekstu z domyślną wartością undefined
export const UserDataContext = createContext<UserDataContextType | undefined>(undefined);

// Hak do korzystania z kontekstu użytkownika
export const useUserData = (): UserDataContextType => {
  const context = useContext(UserDataContext);
  if (!context) {
    throw new Error("useUserData must be used within a UserDataProvider");
  }
  return context;
};

// Interfejs dla komponentu dostawcy kontekstu
interface UserDataProviderProps {
  children: ReactNode;
}

export const UserDataProvider: React.FC<UserDataProviderProps> = ({ children }) => {
  const [userData, setUserData] = useState<UserData>({
    id: "",
    username: "",
    solarEdgeToken: "",
    solarmanToken: "",
    solarmanEmail: "",
    solarmanPassword: "",
    goodweEmail: "",
    goodwePassword: "",
    goodwePowerStationId: "",
    foxessKey: "",
    growattUser: "",
    growattPassword: "",
    fusionSolarUser: "",
    fusionSolarPassword: "",
  });

  const updateUserData = (newData: Partial<UserData>): void => {
    setUserData((prevData) => ({ ...prevData, ...newData }));
  };

  return (
    <UserDataContext.Provider value={{ userData, updateUserData }}>
      {children}
    </UserDataContext.Provider>
  );
};
